import type { RootState } from 'app/store/root/root.state';
import type { Uuid } from 'shared/common/types';
import { createSelector } from '@ngrx/store';
import { selectRootState } from 'app/store/root/root.state';
import * as fromProjects from '../projects/projects.reducer';

export const rootProjectsState = createSelector(
  selectRootState,
  state => state.projects,
);

export const rootProjects = createSelector(
  selectRootState,
  state => fromProjects.selectAll(state.projects),
);

export const oneRootProject = createSelector(
  selectRootState,
  (state: RootState, props: { id: Uuid }) => fromProjects.selectEntities(state.projects)[props.id],
);
